import useInvalidateService from 'hooks/services/useInvalidateService';
import useMutationService from 'hooks/services/useMutationService';
import { useCallback } from 'react';
import accountService from 'services/Account/accountService';
import loginService from 'services/AuthService/Login/loginService';
import sessionService from 'services/AuthService/Login/sessionService';

const useLogout = () => {
  const invalidateService = useInvalidateService();

  const onSettled = useCallback(() => {
    invalidateService(sessionService.getUser);
    invalidateService(accountService.getAccount);
    invalidateService(sessionService.isAdmin);
  }, [invalidateService]);

  return useMutationService(loginService.logout, { onSettled });
};

export default useLogout;
